import '@coddicat/vue-pinch-scroll-zoom/style.css'

import PinchScrollZoom from '@coddicat/vue-pinch-scroll-zoom'
export default ({ app }) => {
  app.component('PinchScrollZoom', PinchScrollZoom)
}
